export default __webpack_public_path__ + "images/6e3f15e0daa76ed9e475155b80951912-basketball.jpg";